let contentService = require('./lib/services/contentService');
let basicInfoService = require('./lib/services/basicInfoService');
let componentService = require('./lib/services/componentService');
module.exports.contentService = contentService;
module.exports.basicInfoService = basicInfoService;
module.exports.componentService = componentService;
